import { render } from "./InitiateReset.vue?vue&type=template&id=56bb06f4&scoped=true"
import script from "./InitiateReset.vue?vue&type=script&lang=js"
export * from "./InitiateReset.vue?vue&type=script&lang=js"

import "./InitiateReset.vue?vue&type=style&index=0&id=56bb06f4&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56bb06f4"]])

export default __exports__